import { useContext } from 'react';
import { Trans } from '@lingui/macro';

import { checkBrandingType } from '@utils/Utils';
import { BasicData } from '@App';

import './style.scss';

const About = () => {
    const { branding, type, theme } = useContext(BasicData);

    return (
        <>
            {checkBrandingType(theme, type) === "consultant" && branding?.consultant_description &&
                <div className='about'>
                    <h3><Trans>About</Trans> {branding?.consultant_name}</h3>
                    <p dangerouslySetInnerHTML={{ __html: branding?.consultant_description }} />
                </div>
            }
            {branding?.company_description &&
                <div className='about'>
                    <h3><Trans>About</Trans> {branding?.company_name}</h3>
                    <div dangerouslySetInnerHTML={{ __html: branding?.company_description }} />
                </div>
            }
        </>
    )
}

export default About;